import React, { Component } from "react";
import VerticalLayout from "../../layout/VerticalLayout";
import CenterLayout from "../../layout/center/CenterLayout";

export default class VerticalLayoutDemo extends Component {
  render() {
    return (
      <VerticalLayout vgap={20}>
        <CenterLayout className="bg1" width={100} height={50}>
          Left 1
        </CenterLayout>
        <CenterLayout className="bg2" width={100} height={50}>
          Left 2
        </CenterLayout>
        <CenterLayout className="bg3" width={100} height={50}>
          Left 3
        </CenterLayout>
        <CenterLayout className="bg4" width={100} height={50}>
          Left 4
        </CenterLayout>
        <CenterLayout className="bg5" width={100} height={50}>
          Left 5
        </CenterLayout>
      </VerticalLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/layout/demo.verticalLayout.js